// Generated by LispyScript v1.0.0
var vue = require("vue/dist/vue");
var app = require("./app.ls");
require("./styles/main.css");
new vue({
    el: "#app",
    render: function(h) {
        return h(app);
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/main.ls
// module id = 8
// module chunks = 0